/**
 * ACH Components i18n
 * Internal translations for ACH Editor and Player components
 */

export interface ACHTranslations {
  preview: string;
  previewUpdating: string;
  previewPlaceholder: string;
  fullscreen: string;
  exitFullscreen: string;
  refresh: string;
  refreshing: string;
  loading: string;
  loadError: string;
  invalidContentType: string;
  noContent: string;
}

const en: ACHTranslations = {
  preview: 'Preview',
  previewUpdating: '(updating...)',
  previewPlaceholder: 'Preview will appear here after content is loaded',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit',
  refresh: 'Refresh',
  refreshing: 'Refreshing...',
  loading: 'Loading content...',
  loadError: 'Failed to load content',
  invalidContentType: 'This content is H5P type, not ACH. Use H5PEditor instead.',
  noContent: 'No content to edit. Provide either content or contentId prop.',
};

const vi: ACHTranslations = {
  preview: 'Xem trước',
  previewUpdating: '(đang cập nhật...)',
  previewPlaceholder: 'Nội dung xem trước sẽ hiển thị sau khi tải xong',
  fullscreen: 'Toàn màn hình',
  exitFullscreen: 'Thoát',
  refresh: 'Làm mới',
  refreshing: 'Đang làm mới...',
  loading: 'Đang tải nội dung...',
  loadError: 'Không thể tải nội dung',
  invalidContentType: 'Nội dung này là H5P, không phải ACH. Hãy sử dụng H5PEditor.',
  noContent: 'Không có nội dung để chỉnh sửa. Vui lòng cung cấp content hoặc contentId.',
};

const translations: Record<string, ACHTranslations> = {
  en,
  vi,
};

let currentLocale = 'en';

export function setLocale(locale: string): void {
  if (translations[locale]) {
    currentLocale = locale;
  }
}

export function getLocale(): string {
  return currentLocale;
}

export function t<K extends keyof ACHTranslations>(key: K): string {
  return translations[currentLocale]?.[key] || translations.en[key] || key;
}

export function useACHTranslations(): ACHTranslations {
  return translations[currentLocale] || translations.en;
}

export default { t, setLocale, getLocale, useACHTranslations };
